import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import {
  Flag,
  FlagDivider,
} from "scmp-app/components/content/content-headline/content-headline-tag/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Headline = styled(EntityLink)`
  display: block;

  color: #000000;
  font-weight: 600;
  font-size: 18px;
  font-family: ${fontSourceSerif4};
  font-style: normal;
  line-height: 120%;
  letter-spacing: -0.36px;

  &:hover {
    text-decoration: underline;
  }

  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
    letter-spacing: -0.4px;
  }

  h2 {
    margin: 0;
  }

  ${Flag} {
    color: #727272;
    font-style: italic;
  }

  ${FlagDivider} {
    font-style: normal;
  }
`;

export const Timestamp = styled.div`
  margin-block-start: 8px;

  color: #727272;
  font-weight: 400;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 100%;
`;

export const CoverLink = styled(EntityLink)`
  display: block;

  overflow: hidden;
  aspect-ratio: 3 / 2;

  ${theme.breakpoints.up("tablet")} {
    aspect-ratio: 1 / 1;
  }
`;

export const InlineCover = styled.div`
  margin-block-start: 4px;
  margin-block-start: 12px;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const Section = styled.div`
  margin-block-end: 8px;

  span {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    font-family: ${fontRobotoCondensed};
    font-style: normal;
    line-height: normal;
    text-transform: uppercase;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  :not(:first-of-type) {
    margin-block-start: 16px;
    padding-block-start: 12px;
    border-block-start: 1px #dfdfdf solid;
  }

  ${theme.breakpoints.up("tablet")} {
    :not(:first-of-type) {
      margin-block-start: 12px;
      padding-block-start: 12px;
      border-block-start: 1px #dfdfdf solid;
    }
  }
`;
